export const NEW_LOGIN_SUCCESS = "NEW_LOGIN_SUCCESS";
export const NEW_LOGIN_ERROR = "NEW_LOGIN_ERROR";
export const NEW_LOGIN_START = "NEW_LOGIN_START";
export const NEW_LOGIN_PROFILE_PIC = "NEW_LOGIN_PROFILE_PIC";
export const CLEAR_ADMIN_PREVIOUS_REDUCER = "CLEAR_ADMIN_PREVIOUS_REDUCER";
